module.exports = __webpack_public_path__ + "865b55d9b312cb2174d18965bf43ab04.png";